import React from 'react';

const Intro = () => <div>Intro</div>;

export default Intro;
